<!-- The sign-in pages and the public application form opt into 'empty' through route data. -->
@if (layout === 'empty') {
    <empty-layout></empty-layout>
}

@if (layout === 'classy') {
    <classy-layout></classy-layout>
}
